import { useEffect, useState } from 'react';

// Service
import ReferralService from '../../services/referralService';
import { stockControllUtils } from '../../utils/stockControll-utils';

const useReferral = (referralId) => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        pageNumber: 1,
        pageSize: 10
    })

    const [referral, setReferral] = useState({
        details: [],
        totalResults: 0,
        totalPage: 0,
    })

    useEffect(() => {
        const getFromServer = () => {
            setLoading(true);
            ReferralService
                .Get(referralId)
                .then(res => setReferral({
                    ...res,
                    details: res.details.map(d => ({ 
                        ...d, 
                        difference: stockControllUtils.formatDiferrence( stockControllUtils.calculateDiffernce(Math.abs(d.quantity), d.plannedQuantity) ) 
                    }))
                }))
                .finally(() => setLoading(false))
        }

        if(referralId) 
            getFromServer();
    }, [referralId]);

    const replacePageNumber = ( pageNumber ) => {
        if(pageNumber < 1)
            pageNumber = 1;

        setFilters(state => ({ ...state, pageNumber }));
    }

    const replacePageSize = (pageSize) => {
        if(pageSize < 1)
            pageSize = 1;

        setFilters(state => ({ ...state, pageNumber: 1, pageSize }));
    }

    return {
        referral,
        loading,
        filters,
        replacePageNumber,
        replacePageSize,
        setFilters,
    };
}

export default useReferral;
